/* eslint-disable */
import { useEffect, useState } from 'react';
import { useShellStore } from './shellStore';

// ============================================================
// useCondense — the back-to-top signal, and (when CONDENSE_ON_SCROLL is on)
// condense on scroll: the app bar slides away after 140px of downward
// scroll and returns on any upward scroll or near the top.
//
// CONDENSE_ON_SCROLL is OFF since the cutover (David, 11.10): every sticky
// rail under the bar — the Orders deck and the Table pin, the Desk list
// toolbar, the QC Data pin — sits at the chrome's resting bottom edge, and
// while the app bar slid away a 56 px band of content showed between the bar
// and the rail. The slide comes back as its own task once those rails
// follow a live chrome edge; until then the chrome's height is a constant.
// ============================================================

export const CONDENSE_ON_SCROLL = false;

export function useCondense(enabled = true) {
  const setCondensed = useShellStore((s) => s.setCondensed);
  const [toTop, setToTop] = useState(false);
  useEffect(() => {
    if (!enabled) { setCondensed(false); return; }
    let lastY = window.scrollY || 0;
    const onScroll = () => {
      const y = window.scrollY || 0;
      if (CONDENSE_ON_SCROLL) {
        if (y > 140 && y > lastY + 6) setCondensed(true);
        else if (y < lastY - 6 || y < 60) setCondensed(false);
      }
      setToTop(y > 700);
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => { window.removeEventListener('scroll', onScroll); setCondensed(false); };
  }, [enabled, setCondensed]);
  return toTop;
}

export function useMediaMax(px) {
  const q = `(max-width: ${px}px)`;
  const [m, setM] = useState(() => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : false));
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => { mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on); };
  }, [q]);
  return m;
}
